export const getWindowLocation = () => window.location;
